import module from "../helper/inject";

/** @type jQuery **/
const $ = module.$();

$(document).ready(() => {
    const inputs = $('[input-plus-minus]');

    inputs.each(function () {
        const ref = $(this);
        const [min, max] = ['min', 'max'].map(i => parseInt(ref.attr(i), 10));
        const input = ref.find('input');
        const incrementer = ref.find('[input-increment]');

        const calculateValue = (inputValue, changeValue) => {
            const newValue = parseInt(inputValue, 10) + parseInt(changeValue, 10);
            console.log('new val ', newValue);
            return Math.min(max, Math.max(min, newValue));
        };

        incrementer.each(function () {
            const amount = parseInt($(this).attr('input-increment'), 10);
            $(this).on('click', () => input.val(calculateValue(input.val(), amount)).change());
            $(this).find('.inputValue').on('change', () => input.val(calculateValue(input.val(), amount)).change());
        });
    })
});